export class ActivatableTransport {

  selected: boolean;

  id: number;
  carrier: string;
  string2: string;
  registrationCode: string;
  identifier: string;
  options: string;
  cargo: string;
  planningDate: string;
  planningDateSortValue: number;

  constructor(transport: ActivatableTransport) {
    this.id = transport.id;
    this.carrier = transport.carrier;
    this.string2 = transport.string2;
    this.registrationCode = transport.registrationCode;
    this.identifier = transport.identifier;
    this.options = transport.options;
    this.cargo = transport.cargo;
    this.planningDate = transport.planningDate;
    this.planningDateSortValue = transport.planningDateSortValue;
  }
}
